import { breakpoints } from "./utilities.js";


export default function() {
	$('.m-tabs.js-internal:not(.js-tabs-done)').each(function() {
		const wrapper = $(this);
		const title = wrapper.find('.js-tabs-title');
		const linksGroup = wrapper.find('.js-tabs-links');
		const links = linksGroup.find('.js-tabs-links-link');
		const tabsGroup = wrapper.find('.js-tabs-tab');
		let allow = true;
		let clicks = 0;

		// hide tabs
		tabsGroup.hide();

		// title click
		title.on('click', function() {
			if (!allow) {
				return false;
			}
			allow = false;
			// toggle nav
			linksGroup.slideToggle(250, function() {
				// toggle class
				title.toggleClass('active');
				// allow
				allow = true;
			});

			return false;
		});

		// links click
		links.on('click', function() {
			const link = $(this);
			const tab = tabsGroup.filter(link.attr('href'));

			if (!allow || !tab.length) {
				return false;
			}
			allow = false;
			// toggle class
			links.removeClass('active');
			link.addClass('active');
			// hide tabs
			tabsGroup.hide();
			// show tab
			tab.show();
			//map resize
			window.site.win.resize();
			// set title
			title.html(link.html());
			// collapse
			if (window.matchMedia('(max-width: ' + (breakpoints.desktop - 1) + 'px)').matches) {
				linksGroup.slideUp(250, function() {
					title.removeClass('active');
					allow = true;
				});
			}
			else {
				allow = true;
			}

			window.site.win.trigger({
				type: "tabsChange",
				wrapper,
				tab,
				link
			}); // Fake Callback

			return false;
		});

		// set active 
		if (links.filter('.active').length) { // TODO ST-4643
			links.filter('.active').click();
		}
		else {
			links.first().click();
		}
		// done
		wrapper.addClass('js-tabs-done');
	});
}
